export const getFrequencyEnum = (state) => state.frequencyEnum
export const getContextEnum = (state) => state.contextEnum
export const getTemplates = (state) => state.templates
export const getSuiteApps = (state) => state.suiteApps